import { CALENDAR_EVENT_COLORS } from './classroomConstants';

const getNextWeekday = (dayOfWeek, hour, minute = 0) => {
  const now = new Date();
  const result = new Date(now);
  const currentDay = now.getDay();
  const daysUntil = (dayOfWeek - currentDay + 7) % 7;
  result.setDate(now.getDate() + daysUntil);
  result.setHours(hour, minute, 0, 0);
  return result;
};

const addHours = (date, hours) => {
  const result = new Date(date);
  result.setHours(result.getHours() + hours);
  return result;
};

const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

// Generate events for current + next 2 weeks
const generateWeeklyEvents = (baseEvents) => {
  const allEvents = [];
  for (let weekOffset = 0; weekOffset < 3; weekOffset++) {
    baseEvents.forEach((event, idx) => {
      const start = addDays(event.start, weekOffset * 7);
      const end = addDays(event.end, weekOffset * 7);
      allEvents.push({
        ...event,
        id: `${event.id}-w${weekOffset}`,
        start: start.toISOString(),
        end: end.toISOString(),
      });
    });
  }
  return allEvents;
};

const baseLiveSessions = [
  {
    id: 'math-live',
    title: 'Mathematics - Live Lesson',
    type: 'live_session',
    start: getNextWeekday(1, 9, 0), // Monday 9:00
    end: getNextWeekday(1, 10, 30), // Monday 10:30
    backgroundColor: CALENDAR_EVENT_COLORS.live_session,
    borderColor: CALENDAR_EVENT_COLORS.live_session,
    extendedProps: {
      sectionName: 'Mathematics',
      teacherName: 'Anna Lindberg',
      type: 'live_session',
    },
  },
  {
    id: 'swedish-live',
    title: 'Swedish - Live Lesson',
    type: 'live_session',
    start: getNextWeekday(2, 10, 0), // Tuesday 10:00
    end: getNextWeekday(2, 11, 30),
    backgroundColor: CALENDAR_EVENT_COLORS.live_session,
    borderColor: CALENDAR_EVENT_COLORS.live_session,
    extendedProps: {
      sectionName: 'Swedish',
      teacherName: 'Erik Johansson',
      type: 'live_session',
    },
  },
  {
    id: 'history-live',
    title: 'History - Live Lesson',
    type: 'live_session',
    start: getNextWeekday(3, 13, 0), // Wednesday 13:00
    end: getNextWeekday(3, 14, 30),
    backgroundColor: CALENDAR_EVENT_COLORS.live_session,
    borderColor: CALENDAR_EVENT_COLORS.live_session,
    extendedProps: {
      sectionName: 'History',
      teacherName: 'Maria Svensson',
      type: 'live_session',
    },
  },
  {
    id: 'science-live',
    title: 'Science - Live Lesson',
    type: 'live_session',
    start: getNextWeekday(4, 9, 0), // Thursday 9:00
    end: getNextWeekday(4, 10, 30),
    backgroundColor: CALENDAR_EVENT_COLORS.live_session,
    borderColor: CALENDAR_EVENT_COLORS.live_session,
    extendedProps: {
      sectionName: 'Science',
      teacherName: 'Lars Nilsson',
      type: 'live_session',
    },
  },
  {
    id: 'english-live',
    title: 'English - Live Lesson',
    type: 'live_session',
    start: getNextWeekday(5, 11, 0), // Friday 11:00
    end: getNextWeekday(5, 12, 30),
    backgroundColor: CALENDAR_EVENT_COLORS.live_session,
    borderColor: CALENDAR_EVENT_COLORS.live_session,
    extendedProps: {
      sectionName: 'English',
      teacherName: 'Anna Lindberg',
      type: 'live_session',
    },
  },
];

const assignmentEvents = [
  {
    id: 'math-hw1',
    title: 'Mathematics - Assignment 1 Due',
    type: 'assignment_due',
    start: addDays(getNextWeekday(3, 23, 59), 0).toISOString(),
    end: addDays(getNextWeekday(3, 23, 59), 0).toISOString(),
    allDay: true,
    backgroundColor: CALENDAR_EVENT_COLORS.assignment_due,
    borderColor: CALENDAR_EVENT_COLORS.assignment_due,
    extendedProps: {
      sectionName: 'Mathematics',
      teacherName: 'Anna Lindberg',
      type: 'assignment_due',
    },
  },
  {
    id: 'swedish-essay',
    title: 'Swedish - Essay Submission',
    type: 'assignment_due',
    start: addDays(getNextWeekday(5, 23, 59), 0).toISOString(),
    end: addDays(getNextWeekday(5, 23, 59), 0).toISOString(),
    allDay: true,
    backgroundColor: CALENDAR_EVENT_COLORS.assignment_due,
    borderColor: CALENDAR_EVENT_COLORS.assignment_due,
    extendedProps: {
      sectionName: 'Swedish',
      teacherName: 'Erik Johansson',
      type: 'assignment_due',
    },
  },
  {
    id: 'history-exam',
    title: 'History - Mid-term Exam',
    type: 'exam',
    start: addDays(getNextWeekday(3, 13, 0), 14).toISOString(),
    end: addDays(getNextWeekday(3, 15, 0), 14).toISOString(),
    backgroundColor: CALENDAR_EVENT_COLORS.exam,
    borderColor: CALENDAR_EVENT_COLORS.exam,
    extendedProps: {
      sectionName: 'History',
      teacherName: 'Maria Svensson',
      type: 'exam',
    },
  },
];

export const generateMockCalendarEvents = () => {
  const weeklyEvents = generateWeeklyEvents(baseLiveSessions);
  return [...weeklyEvents, ...assignmentEvents];
};

export const getUpcomingEvents = (count = 5) => {
  const now = new Date();
  const allEvents = generateMockCalendarEvents();
  return allEvents
    .filter((e) => new Date(e.start) > now)
    .sort((a, b) => new Date(a.start) - new Date(b.start))
    .slice(0, count);
};
